/**
 * リダクション種別
 */
export var ReductionTypes;

(function (ReductionTypes) {
  /**
   * モデル
   */
  ReductionTypes[ReductionTypes["Model"] = 1] = "Model";
  /**
   * オーディオ
   */

  ReductionTypes[ReductionTypes["Audio"] = 2] = "Audio";
  /**
   * 動画
   */

  ReductionTypes[ReductionTypes["Movie"] = 3] = "Movie";
})(ReductionTypes || (ReductionTypes = {}));